var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSpinner = function SvgSpinner(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-spinner": "true",
    viewBox: "0 0 128 128",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112 52.54A33.94 33.94 0 0 0 102.8 35L93 40.85c3.68 3.9 6.13 8.28 6.74 13.15 7.36-.97 4.3-.49 12.26-1.46M93 25.8c-4.87-4.9-11.2-8.57-17.54-9.8-.97 7.97-.49 4.9-1.46 12.26 4.87.61 9.26 3.06 13.15 6.74zM64.3 100c-19.92 0-36.22-16.2-36.22-36 0-18 13.88-33.6 31.4-36l-1.82-12C34.11 19.6 16 40 16 64c0 26.4 21.74 48 48.3 48 24.15 0 44.68-17.4 47.7-41.4l-12.08-1.8C98.12 86.2 82.42 100 64.3 100"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSpinner);
export default ForwardRef;